<div class="modal-header">
  <h4 class="modal-title">Receipt</h4>
  <button
    type="button"
    class="btn-close"
    (click)="closeModal()"
    aria-label="Close"
  ></button>
</div>

<div class="modal-body">
  <div
    class="upload-area"
    [class.has-file]="selectedFile"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    <div class="upload-prompt" *ngIf="!selectedFile">
      <i class="tio-publish fs-1"></i>
      <h3>Drop file here or click to upload</h3>
      <p class="text-muted">Supported formats: PDF, PNG, JPG, JPEG</p>
      <input
        #fileInput
        type="file"
        class="d-none"
        (change)="onFileSelected($event)"
        accept=".pdf,.png,.jpg,.jpeg"
      />
      <button class="btn btn-outline-primary" (click)="fileInput.click()">
        Select File
      </button>
    </div>

    <div class="selected-file" *ngIf="selectedFile">
      <div class="d-flex align-items-center mb-2">
        <i
          class="tio-file me-2"
          [class.tio-photo_square_outlined]="
            selectedFile.type.includes('image')
          "
        ></i>
        <div class="flex-grow-1">
          <strong>{{ selectedFile.name }}</strong
          ><br />
          <small class="text-muted">{{ selectedFile.size }}</small>
        </div>
        <button class="btn btn-sm btn-link text-danger" (click)="removeFile()">
          Remove
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="closeModal()">
    Cancel
  </button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="!selectedFile"
    (click)="uploadReceipt()"
  >
    Upload
  </button>
</div>
